import { Component } from '@angular/core';
import { ModalService } from '../../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { BankAccountDto } from '../../../../api/dtos/BankAccountDto';
import { ApiAdminBankAccount } from '../../../../api/endpoints/ApiAdminBankAccount';
import { ApiClientAdminBankAccount } from '../../../../api/endpoints/ApiClientAdminBankAccount';

@Component({
  standalone: false,
  selector: 'mf-bank-account-edit',
  templateUrl: './bank-account-edit.component.html',
  styleUrls: ['./bank-account-edit.component.scss'],
})
export class BankAccountEditComponent {
  constructor(
    private _apiAdminBankAccount: ApiAdminBankAccount,
    private _apiClientAdminBankAccount: ApiClientAdminBankAccount,
    private _modalService: ModalService
  ) {
    this.load();
  }

  bankAccountDto: BankAccountDto;

  async load() {
    this.bankAccountDto = await this._apiClientAdminBankAccount.getById(this._modalService.openData);
  }

  save(bankAccountDto: BankAccountDto) {
    bankAccountDto.isVerified = false;
    this._apiClientAdminBankAccount
      .edit(bankAccountDto)
      .then(() => {
        this._modalService.closeAsSuccess('Cuenta editada correctamente');
      })
      .catch((err) => {
        if (err?.error?.message) {
          this._modalService.closeAsCancel(err?.error?.message);
        }
      });
  }

  verify() {
    this._apiAdminBankAccount
      .validate(this.bankAccountDto)
      .then(() => {
        this.bankAccountDto.isVerified = true;
        this._modalService.closeAsSuccess('Titular verificado correctamente');
      })
      .catch(() => {
        this._modalService.closeAsCancel();
      });
  }
}
